var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReplyIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 14,
  viewBox: "0 0 15 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.99998 0.864258V4.34878C2.6342 4.55438 0.333313 6.82307 0.333313 11.0001V12.6096L1.47138 11.4715C2.96927 9.97363 4.79345 9.34605 6.99998 9.58133V13.1359L14.0124 7.0001L6.99998 0.864258ZM8.33331 5.66677V3.80262L11.9876 7.0001L8.33331 10.1976V8.43535L7.77624 8.34251C5.49985 7.96311 3.49626 8.34311 1.80081 9.4778C2.29967 6.90079 4.19955 5.66677 7.66664 5.66677H8.33331Z",
  fill: "#636766"
})));
export { SvgReplyIcon as ReactComponent };
export default __webpack_public_path__ + "440adbc26998de68719bbf048d5452f4.svg";